module.exports = __webpack_public_path__ + "img/homepage-content-image-infiniti.b8c2ce56.jpg";